export const NOT_WHITESPACE = 'No se admite espacios en blanco';
export const NOT_NUMBER = 'No se admite números';
export const NOT_SPECIAL_CHARACTER = 'No se admite caracteres especiales';
export const ONLY_UPPERCASE = 'Solo se admiten mayusculas.';
export const ONLY_LOWERCASE = 'No se permiten caracteres especiales, mayusculas y espacios.';
export const REQUIRED = 'Este campo es obligatorio.';
export const MIN_3 = 'Debe tener al menos 3 caracteres.';
export const MIN_5 = 'Debe tener al menos 5 caracteres.';
export const MIN_8 = 'Debe tener al menos 8 caracteres.';
export const ONLY_LETTERS = 'No se permiten caracteres especiales y numeros.';